import { toast } from "react-toastify";
import { ImageConstants } from "../_constants";
import { ImageService } from "../_services";

export const ImageActions = {
  getImagesForWorld,
  getImagesForChronicle,
  upload,
  update,
  delete: deleteImage,
  deleteMultiple,
};

function getImagesForWorld(worldID) {
  return (dispatch) => {
    dispatch(request(worldID));

    return ImageService.getImagesByWorld(worldID).then(
      (images) => {
        dispatch(success(images));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Retrieve Images: `, message);
        toast.warning(`Unable to retrieve images for this Chronicle.`);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: ImageConstants.FETCH_WORLD_REQUEST,
      params,
    };
  }

  function success(images) {
    return {
      type: ImageConstants.FETCH_WORLD_SUCCESS,
      payload: images,
    };
  }

  function failure(error) {
    return {
      type: ImageConstants.FETCH_WORLD_FAILURE,
      error,
    };
  }
}

function getImagesForChronicle(chronicleID) {
  return (dispatch) => {
    dispatch(request(chronicleID));

    return ImageService.getImagesByChronicle(chronicleID).then(
      (images) => {
        dispatch(success(images));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Retrieve Images: `, message);
        toast.warning(`Unable to retrieve images for this Chronicle.`);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: ImageConstants.FETCH_CHRONICLE_REQUEST,
      params,
    };
  }

  function success(images) {
    return {
      type: ImageConstants.FETCH_CHRONICLE_SUCCESS,
      payload: images,
    };
  }

  function failure(error) {
    return {
      type: ImageConstants.FETCH_CHRONICLE_FAILURE,
      error,
    };
  }
}

function upload(imageData) {
  return (dispatch) => {
    dispatch(request(imageData));

    return ImageService.uploadImage(imageData).then(
      (images) => {
        toast.success(`Image Upload successful!`);
        dispatch(success(images));
        return images;
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Image Upload: `, message);
        toast.error(`An error occurred during the upload process.`);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: ImageConstants.UPLOAD_IMAGE_REQUEST,
      params,
    };
  }

  function success(images) {
    return {
      type: ImageConstants.UPLOAD_IMAGE_SUCCESS,
      payload: images,
    };
  }

  function failure(error) {
    return {
      type: ImageConstants.UPLOAD_IMAGE_FAILURE,
      error,
    };
  }
}

function update(imageID, imageData) {
  return (dispatch) => {
    dispatch(request(imageData));

    return ImageService.updateImage(imageID, imageData).then(
      (image) => {
        toast.success(`Image successfully updated!`);
        dispatch(success(image));
        return image;
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Image Update: `, message);
        toast.error(`Unable to update Image. Please try again in a moment.`);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: ImageConstants.UPDATE_IMAGE_REQUEST,
      params,
    };
  }

  function success(image) {
    return {
      type: ImageConstants.UPDATE_IMAGE_SUCCESS,
      payload: image,
    };
  }

  function failure(error) {
    return {
      type: ImageConstants.UPDATE_IMAGE_FAILURE,
      error,
    };
  }
}

function deleteImage(imageID) {
  return (dispatch) => {
    dispatch(request(imageID));

    return ImageService.deleteImage(imageID).then(
      (response) => {
        toast.success("Image successfully deleted.");
        dispatch(success(imageID));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Delete Image: `, message);
        toast.error(`Unable to delete Image. Please try again in a moment.`);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: ImageConstants.DELETE_IMAGE_REQUEST,
      params,
    };
  }

  function success(imageID) {
    return {
      type: ImageConstants.DELETE_IMAGE_SUCCESS,
      payload: imageID,
    };
  }

  function failure(error) {
    return {
      type: ImageConstants.DELETE_IMAGE_FAILURE,
      error,
    };
  }
}

function deleteMultiple(imageIDs) {
  return (dispatch) => {
    dispatch(request(imageIDs));

    return ImageService.deleteMultipleImages(imageIDs).then(
      (response) => {
        toast.success("Images successfully deleted!");
        dispatch(success(imageIDs));
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Delete Images: `, message);
        toast.error(
          `Unable to delete the requested Images. Please try again in a moment.`
        );
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: ImageConstants.DELETE_MULTIPLE_IMAGE_REQUEST,
      params,
    };
  }

  function success(items) {
    return {
      type: ImageConstants.DELETE_MULTIPLE_IMAGE_SUCCESS,
      payload: items,
    };
  }

  function failure(error) {
    return {
      type: ImageConstants.DELETE_MULTIPLE_IMAGE_FAILURE,
      error,
    };
  }
}
